<template>
    <div class="col-item">
            <div class="col-title-wrapper">
                <h2 class="title">{{title}}</h2>
                <a href="#" class="btn success no-bg" @click.prevent="addItem" >
                    <icon-base width="14" height="14" viewBox="0 0 20 21"><icon-plus/></icon-base>
                    <span>Add new</span>
                </a>
            </div>

            <div class="sort-wrapper">
                <div class="sort-box">
                    <span>Sort by:</span>
                    <p class="item" :class="openSort ? 'active' : ''" @click="openSort = !openSort">
                        <span>{{filterParam}}</span>
                        <icon-base width="11" height="7" viewBox="0 0 11 7"><icon-arrow-down/></icon-base>
                    </p>
                </div>
                <!--<div class="mobile-filter-box">
                    <span class="mobile-filter-btn">
                        <icon-base width="15" height="15" viewBox="0 0 15 15"><icon-filter-mobile/></icon-base>
                        <span>Filter</span>
                    </span>
                </div>-->
            </div>

            <!--<div class="filter-result-items">
                <div class="item">
                    <div class="item-icon-close">
                        <svg width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M11.2075 12.5L0 1.29249L0.79249 0.5L12 11.7075L11.2075 12.5Z" fill="white"></path>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M4.63779e-07 11.7075L11.2075 0.5L12 1.29249L0.792492 12.5L4.63779e-07 11.7075Z" fill="white"></path>
                        </svg>
                    </div>
                    <div class="item-box">
                        <p class="item-title">Name:</p>
                        <div class="item-result">Cobham 6075 LX</div>
                    </div>
                </div>
                <div class="item">
                    <div class="item-icon-close">
                        <svg width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M11.2075 12.5L0 1.29249L0.79249 0.5L12 11.7075L11.2075 12.5Z" fill="white"></path>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M4.63779e-07 11.7075L11.2075 0.5L12 1.29249L0.792492 12.5L4.63779e-07 11.7075Z" fill="white"></path>
                        </svg>
                    </div>
                    <div class="item-box">
                        <p class="item-title">Ref:</p>
                        <p class="item-result">COL-LAN-SCM-0750610</p>
                    </div>
                </div>
            </div>-->

            <div class="table-box">
                <div class="table terminal-types-table">
                    <div class="table-head" :style="openSort ? 'display: flex;': ''">
                        <simple-table-filter name="name" label="Name" @filter="filterClick" :param="filterParam"/>
                        <simple-table-filter name="ref" label="Ref" @filter="filterClick" :param="filterParam"/>
                        <!--<table-filter class="name-col" name="Name" :options="selectOptions" @submit="changeFilter"/>-->
                        <!--<table-filter class="ref-col" name="Ref" :options="selectOptions" @submit="changeFilter"/>-->
                        <div class="col btn-col"></div>

                    </div>

                    <div class="table-body" :class="loading ? 'loading' : ''">
                        <div class="row" v-for="(item, index) in items" v-bind:key="index">
                            <div class="col name-col"><p>{{item.name}}</p></div>
                            <div class="col ref-col"><p>{{item.ref}}</p></div>
                            <div class="col btn-col">
                                <a href="#" class="extend-btn light-green small-btn" data-title="Edit" @click.prevent="editItem(item)">
                                    <icon-base width="25" height="25" viewBox="0 0 25 25"><icon-pencil/></icon-base>
                                    <span>Edit</span>
                                </a>
                                <a href="#" class="delete-btn light-red small-btn" data-title="Delete" @click.prevent="deleteItem(item.id)">
                                    <icon-base width="20" height="21" viewBox="0 0 20 21"><icon-trash/></icon-base>
                                    <span>Delete</span>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>

                 <a href="" class="js-show-more"  @click.prevent="loadMore" v-if="loadMoreItems">Show more</a>
            </div>
        </div>
</template>

<script>

import IconBase from "../../common/IconBase";
import IconPlus from "../../common/icons/IconPlus";
import IconPencil from "../../common/icons/IconPencil";
import IconTrash from "../../common/icons/IconTrash";
import {mapMutations, mapActions} from "vuex"
import Confirm from "../../common/Confirm"
import LXSettingsForm from "../../Admin/Settings/LXSettingsForm"
import IconArrowDown from "../../common/icons/IconArrowDonw";
import SimpleTableFilter from "../../common/SimpleTableFilter";
/*import IconFilterMobile from "../../common/icons/IconFilterMobile";*/

export default {
    name: 'terminal-types',

    props: {
        loadMoreItems: { type: Boolean, default: false },
        title: String,
        items: {
            type: Array,
        },
        type: { type: String, default: 'terminal'}
    },

    data() {
        return {
            loadMoreTypes: true,
            currentPage: 1,
            openSort: false,
            loading: false,
            filterParam: 'name',
            order: false,
        }
    },

    mounted() {
        this.loadFunc({sort: !this.order ? '-' + this.filterParam : this.filterParam, page: this.currentPage});
    },

    components: {
        SimpleTableFilter, IconArrowDown, IconTrash, IconPencil, IconPlus, IconBase, /*IconFilterMobile,*/
    },

    methods: {
        ...mapMutations([
            'switchPopup',
            'setPopupComponent',
            'setPopupData'
        ]),
        ...mapMutations('settings', [
            'resetTerminalTypes',
            'resetSubscriptions'
        ]),
        ...mapActions('settings', [
            'getLXSettings',
            'addType',
            'addSubscription',
            'updateType',
            'updateSubscription',
            'getTerminalTypes',
            'deleteSubscription',
            'deleteTerminalType',
            'getSubscriptions',
        ]),
        loadFunc(params) {
            this.loading = true;
            const func = this.type === 'terminal' ? this.getTerminalTypes : this.getSubscriptions;
            func(params).then(() => {this.loading = false});
        },
        loadMore() {
            this.currentPage += 1;
            this.loadFunc({sort: !this.order ? '-' + this.filterParam : this.filterParam, page: this.currentPage})
        },
        addItem() {
            this.setPopupComponent(LXSettingsForm);
            this.setPopupData({type: 'add', title: this.title, func: this.type === 'terminal' ? this.addType : this.addSubscription});
            this.switchPopup(true);
        },
        deleteItem(id) {
            this.setPopupComponent(Confirm);
            this.setPopupData({id: id, func: this.type === 'terminal' ? this.deleteTerminalType : this.deleteSubscription});
            this.switchPopup(true);
        },
        editItem(item) {
            this.setPopupComponent(LXSettingsForm);
            this.setPopupData({id: item.id, type: 'edit', item: item, title: this.title, func: this.type === 'terminal' ? this.updateType : this.updateSubscription});
            this.switchPopup(true);
        },
        filterClick(value) {
            this.filterParam = value.name;
            this.order = value.order;
            this.openSort = false;

            if (this.filterParam) {
                this.loading = true;

                this.type === 'terminal' ? this.resetTerminalTypes() : this.resetSubscriptions();
                this.currentPage = 1;

                if (this.type === 'terminal') {
                    this.getTerminalTypes({sort: !this.order ? '-' + this.filterParam : this.filterParam}).then(() => {
                        this.loading = false;
                    });
                } else {
                    this.getSubscriptions({sort: !this.order ? '-' + this.filterParam : this.filterParam}).then(() => {
                        this.loading = false;
                    });
                }

            }
        },
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
